// api-entity prefixes errors with this when a query took too long to calculate (e.g. MediaValueRowsV3)
const QUERY_TIMED_OUT_MESSAGE_PREFIX = 'Query timed out';

export function shouldRetryQuery(
    failureCount: number,
    error: {message: string; statusCode?: number}
): boolean {
    // dont retry any 404s
    //
    // our api doesn't return standardised errors, so sometimes a 404 is on the
    // statusCode and sometimes it isnt
    if (error.message.includes('404') || error.statusCode === 404) {
        return false;
    }
    // the same query will time out again, and retrying only adds more load to the cluster
    if (error.message.startsWith(QUERY_TIMED_OUT_MESSAGE_PREFIX)) {
        return false;
    }
    // retry once
    return failureCount < 1;
}
